import axios from 'axios'
import Qs from 'qs'
import store from '../store/index'
import router from '../router'
import { Message } from 'element-ui'
let showMsg = true;
axios.defaults.timeout = 100000;

axios.interceptors.request.use(
  config => {
    if (store.state.userInfo) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = store.state.userInfo.access_token;
      var page_id = document.body.id;
      config.headers.uniqueID = page_id
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });
axios.interceptors.response.use(function (response) {
  // 在接收响应做些什么，例如跳转到登录页\
  if (
    (response.data.code == 500 && response.data.msg == '登录时间超时，请重新登录!') ||
    response.data.msg == '未获取到用户信息,请检查登录状态！'
  ) {
    store.commit('REMOVE_USERINFO')
    router.replace({
      path: '/'
    })
  } else if (response.data.code == 401) {
    if(showMsg) {
      Message.error(response.data.msg);
      showMsg = false
      setTimeout(() => {
        showMsg = true;
      }, 3000);
    }
    store.commit('REMOVE_USERINFO')
    router.replace({
     path: '/'
    })
    return Promise.reject(response.data.msg);
  }else if(response.data.code>=500) {
    Message.error(response.data.msg)
    store.commit('GLOBAL_FLAG', false)
  }
  return response;
  // store.commit('GLOBAL_FLAG', false)
}, error => {
  // 对响应错误做点什么
  store.commit('GLOBAL_FLAG', false)
  store.commit('CHANGE_LOADING', false)
  Message.error(error.response.data.msg)
  return Promise.reject(error);
});

export default {
  fetchGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, { params: params }).then(res => {
        resolve(res.data)
        // localStorage.setItem("total",res.data.total)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchUrlGet(url, params) {
    url = url + params;
    return new Promise((resolve, reject) => {
      axios.get(url).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //一般提交
  fetchPost(url, params = {}) {
    let headers = {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    if (localStorage.getItem('languageSet') == 'en') {
      headers = {
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept-Language': 'en-US;q=0.8,en'
      }
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        headers:headers,
        data: Qs.stringify(params)
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPut(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: url,
        headers: {
          'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Qs.stringify(params)
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPuts(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: url,
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        },
        data: params
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchDelete(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'DELETE',
        url: url,
        headers: {
          'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Qs.stringify(params)
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 我的
  is_me(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        },
        data: params
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //接受二维码图片
  fetchImgPost(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        responseType: "arraybuffer",
        url: url,
        headers: {
          'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Qs.stringify(params)
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //多层数据json提交
  fetchStringPost(url, params = {}) {
    let headers = {
      'Content-type': 'application/json; charset=UTF-8'
    }
    if (localStorage.getItem('languageSet') == 'en') {
      headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'Accept-Language': 'en-US;q=0.8,en'
      }
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        headers: headers,
        data: params,
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //图片流提交
  fetchFilePost(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true,
        data: params
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 接收文件
  fetchFileGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        responseType: "blob",
        withCredentials: true,
        params: params
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchFilePost(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        responseType: "blob",
        withCredentials: true,
        params: params
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取验证码 
  get_captcha(url, data) {
    return axios({
      url: url,
      method: 'post',
      timeout: 40000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      },
      data
    })
  },
  // 检查 验证码
  check_captcha(url, data) {
    return axios({
      url: url,
      method: 'post',
      timeout: 40000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      },
      data
    })
  },
  // 支付订单
  payOrderPost(url, params = {}) {
    let headers = {
      'Content-type': 'application/json; charset=UTF-8'
    }
    if (localStorage.getItem('languageSet') == 'en') {
      headers = {
        'Content-type': 'application/json; charset=UTF-8',
        'Accept-Language': 'en-US;q=0.8,en'
      }
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        timeout: 120000,
        headers: headers,
        data: params,
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // Post提交（英文状态）  'Accept-Language': 'en-US;q=0.8,en'
  fetchPostEnglish(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        headers: {
          'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept-Language': 'en-US;q=0.8,en'
        },
        data: Qs.stringify(params)
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/public.js